import { useEffect, useState } from 'react';
import { hasValue } from '@r-and-a-shared-ui/utils';
import type { ArticleListicleProps } from '../ArticleListicle/ArticleListicle';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';
import { api } from '@r-and-a-shared-ui/randa-trpc-client';

export function useFallbackArticles(
  articlesList: ArticleListicleProps[],
  highLightedArticle: any,
  isEmpty: boolean
) {
  const [fetchedArticles, setFetchedArticles] = useState<ArticleListicleProps[] | null>(null);
  const [fetchedHighlightedArticle, setFetchedHighlightedArticle] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { data, isError, isLoading } = api.kontent.latestArticles.useQuery({
    cache: true,
  }, {
    enabled: isEmpty,
  })

  useEffect(() => {
    if (isEmpty) {
      setLoading(true);

      if (isError) {
        setError('Error fetching articles');
        setLoading(false);
      }
      if (!isLoading) {
        if (hasValue(data?.articles)) {
          // Map the fetched articles
          const mappedHighlightedArticle = kontentAiDataMapping.article_highlight(data!.articles[0]);
          const mappedArticles = data!.articles.slice(1).map((article: any) =>
            kontentAiDataMapping.article_listicle(article)
          );

          setFetchedHighlightedArticle(mappedHighlightedArticle);
          setFetchedArticles(mappedArticles as any);
        } else {
          setError('No articles found');
        }
        setLoading(false);
      }
    } else {
      setFetchedArticles(null);
      setFetchedHighlightedArticle(null);
    }
  }, [isEmpty, data, isError, isLoading]);
  return {
    articles: fetchedArticles || articlesList,
    highlighted: fetchedHighlightedArticle || highLightedArticle,
    loading,
    error,
  };
}
